const state = {
  fullText: '',

  showSelect: null,

  dateFrom: null,
  dateTo: null,
};

const getters = {

};

const actions = {

};

const mutations = {
  setDashboardFilter(state, data){
    state.fullText = data.fullText != ''? data.fullText : null;
    state.showSelect = data.showSelect;
    state.dateFrom = data.dateFrom;
    state.dateTo = data.dateTo;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
